import type React from 'react'

export const IconPage: React.FC<{ width?: number }> = ({ width }) => (
  <svg
    width={width || 17}
    height={width || 16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.25"
      y="1.75"
      width="12.5"
      height="12.5"
      rx="2.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="5.5"
      y="4.5"
      width="6"
      height="1.5"
      rx="0.75"
      fill="currentColor"
    />
  </svg>
)
